module.exports = __webpack_public_path__ + "134007cdf3f9a5c0b21995db0a94236a.woff2";